import ajax from '@/utils/ajax'
export default {
  // 广交会-列表数据
  getCantonFairPage(data) {
    return ajax({
      url: 'gt6/search/getCantonFairPage',
      method: 'POST',
      data
    })
  },
  // 广交会-国家数据
  getCantonFairCountry(data) {
    return ajax({
      url: 'gt6/search/getCantonFairCountry',
      method: 'POST',
      data
    })
  },
  // 广交会-产品类型
  getPurchaseType(params) {
    return ajax({
      url: 'gt6/search/getPurchaseType',
      method: 'GET',
      params
    })
  },
  // 广交会-届次
  getExhibitionSession(data) {
    return ajax({
      url: 'gt6/search/getExhibitionSession',
      method: 'GET',
    })
  },
  // 广交会-采购商商品筛选
  getPurchaseProduct(params) {
    return ajax({
      url: 'gt6/search/getPurchaseProduct',
      method: 'GET',
      params
    })
  },
  // 广交会-历届参展数据
  getHistorySession(params) {
    return ajax({
      url: 'gt6/search/getHistorySession',
      method: 'GET',
      params
    })
  },
}